import { Divider, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, User } from '@heroui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faKey, faSignOutAlt, faUser, faFileContract } from '@fortawesome/free-solid-svg-icons';
import { useAppSelector } from '../../../core/rootHooks';
import { FC } from 'react';
import {  selectUserInfoFormData } from '../../sharedSelectors';
import ModalManager from '../../components/modal/ModalManager';

interface IUserMenuProps {
    isUserSubscribedToHorizon: boolean;
}

const UserMenu: FC<IUserMenuProps> = ({ isUserSubscribedToHorizon }) => {
	const horizonAppUrl = window.config.HORIZON_APP_URL;
	const msiShellAppUrl = window.config.SHELL_APP_URL;
	const userInfo = useAppSelector(selectUserInfoFormData);

	const onSignOut = () => {
		window.location.replace(`${msiShellAppUrl}/account/logout`);
	};

	return (
		<div className="text-msi-black-color">
			<Dropdown placement="bottom-end" radius="none">
				<DropdownTrigger>
					<User
						as="button"
						className="transition-transform align-middle"
						name={userInfo?.fullName}
						description={userInfo?.emailAddress}
						avatarProps={{
							icon: (
								<div className="avatar-circle">
									<span className="initials">{userInfo?.initials}</span>
								</div>
							),
							className: 'w-8 h-8 xl:w-10 xl:h-10 font-semibold',
						}}
					/>
				</DropdownTrigger>
				<DropdownMenu aria-label="Profile Actions" variant="flat">
					<DropdownItem key="profile" className="h-8 gap-2 hover:rounded-none" isReadOnly={true}>
						<p className="font-semibold">{userInfo?.clientName}</p>
					</DropdownItem>
					<DropdownItem key="divider">
						<Divider />
					</DropdownItem>
					<DropdownItem
						key="my-profile"
						className={`hover:rounded-none`}
						onPress={() => {
							if (!isUserSubscribedToHorizon) {
								ModalManager.show({
									header: 'Contact MSI for Account Assistance',
									message: 'Please contact MSI to update your profile.',
									showActionButton: false,
									cancelButtonText: 'Close',
									size: 'sm',
								});
								return;
							}
							window.location.href = `${horizonAppUrl}/user/my-profile`;
						}}
					>
						<FontAwesomeIcon icon={faUser} className="icon mr-2" />
						My Profile
					</DropdownItem>
					<DropdownItem
						key="change-password"
						className="hover:rounded-none"
						onPress={() => {
							window.location.href = `${msiShellAppUrl}/account/change-password`;
						}}
					>
						<FontAwesomeIcon icon={faKey} className="icon mr-2" />
						Change Password
					</DropdownItem>
					<DropdownItem
						key="subscriptions"
						className="hover:rounded-none"
						onPress={() => {
							if (!isUserSubscribedToHorizon) {
								ModalManager.show({
									header: 'Contact MSI for Account Assistance',
									message: 'Please contact MSI to get information about your subscriptions and products.',
									showActionButton: false,
									cancelButtonText: 'Close',
									size: 'sm',
								});
								return;
							}
							window.location.href = `${horizonAppUrl}/user/subscriptions-and-data-updates`;
						}}
					>
						<FontAwesomeIcon icon={faFileContract} className="icon mr-2" />
						Subscriptions & Data Updates
					</DropdownItem>
					<DropdownItem key="logout" color="danger" className="hover:rounded-none" onPress={onSignOut}>
						<FontAwesomeIcon icon={faSignOutAlt} className="icon mr-2" />
						Logout
					</DropdownItem>
				</DropdownMenu>
			</Dropdown>
		</div>
	);
};

export default UserMenu;
